const defaultPanelConfig = [{ id: 'default-all', title: 'All' }];

export default defaultPanelConfig;
